import { openDialog } from '@patrianna/dialog-manager'
import { useIsMobile } from '@patrianna/shared-hooks'
import { skipOtpSelectorWithMandatoryAndClosed } from '@patrianna-payments/shared-store/skip-otp'

import ROUTES from 'config/routes.json'
import { useRouterPushWithCallback } from 'containers/NavigationProvider'
import useCurrencyRedirect from 'hooks/useCurrencyRedirect'
import { useGamePageReload } from 'hooks/useGamePageReload'
import { LoaderFullscreen } from 'src/components/Loader'
import { useAppSelector } from 'src/store/hooks'
import { isAppInitializedSelector } from 'store/modules/appConfig/selectors'
import {
  getUserRestrictionsSelector,
  isLoggedInSelector,
  needToVerifyEmailSelector,
} from 'store/modules/user/selectors'

import type { ReactNode } from 'react'
import type { SupportedCurrencies } from 'types/currencies'

type Props = {
  currency: SupportedCurrencies
  children: ReactNode
  loadingFallback?: ReactNode
}

function GameRedirectWrapper(props: Props) {
  const routerPush = useRouterPushWithCallback()

  const isLoggedIn = useAppSelector(isLoggedInSelector)
  const isAppInitialized = useAppSelector(isAppInitializedSelector)
  const skipOtp = useAppSelector(skipOtpSelectorWithMandatoryAndClosed)
  const userRestrictions = useAppSelector(getUserRestrictionsSelector)
  const emailNotVerified = useAppSelector(needToVerifyEmailSelector)

  const { currency, children, loadingFallback } = props
  const isMobile = useIsMobile()
  useGamePageReload()
  useCurrencyRedirect({ shouldCheckDirectLink: true })

  if (isMobile === null || !isAppInitialized) {
    return loadingFallback ?? <LoaderFullscreen />
  }

  if (isLoggedIn && emailNotVerified) {
    // Don't navigate here: useIsEmailVerified (mounted higher in the tree) already
    // redirects to ROUTES.CONFIRM_EMAIL on this same condition.
    return <LoaderFullscreen />
  }

  if (isLoggedIn && !skipOtp && currency === 'SC') {
    routerPush(ROUTES.HOME, () => {
      openDialog({ dialogName: 'PHONE_VERIFICATION_DIALOG' })
    })

    return <LoaderFullscreen />
  }

  if (isLoggedIn && userRestrictions?.includes?.('no_game')) {
    routerPush(ROUTES.HOME, () => {
      openDialog({ dialogName: 'RESTRICT_USER_DIALOG' })
    })
  }

  return <>{children}</>
}
export default GameRedirectWrapper
